import { useEffect, useState } from "react";
import { useForm, Controller } from "react-hook-form";
import styled from "styled-components";
import theme from "../../styles/theme";

import Button from "../../components/Button";
import FlexBox, { FlexGrow } from "../../components/FlexBox";
import Icon, { ClickableIcon } from "../../components/Icon";
import Input, { InputTextArea } from "../../components/Input";
import { StyledText } from "../../components/Text";
import { SaveButton } from "../../components/PillarOverviewModify";
import axios from "axios";
type EditKnowledgeTypes = {
  currentId?: any;
  isOpen?: boolean;
  header: string;
  mode: "modify" | "create";
  setOpen: (x: boolean) => void;
  isSnackbarOpen: boolean;
  setIsSnackbarOpen: (x: boolean) => void;
  setIsErrorOpen: (x: boolean) => void;
  setMessage: (x: string) => void;
  role: string;
  //   subdomainData?: {
  //     id: string;
  //     description: string;
  //     title: string;
  //     knowledge_areas: Array<{
  //       id: string;
  //       description: string;
  //       title: string;
  //       knowledge_topics: Array<{
  //         id: string;
  //         description: string;
  //         title: string;
  //       }>;
  //     }>;
  //   };
  onSaveComplete: () => void;
};

const Header = styled.h4`
  font-size: 20px;
  font-style: normal;
  font-weight: 700;
  line-height: 28px;
  letter-spacing: 0px;
  text-align: left;
`;
const CustomFlex = styled(FlexBox)`
  padding: 20px 0;
  align-items: center;
  border-bottom: 1px solid #3c406c;
`;
const CustomFlexPlain = styled(FlexBox)`
  padding: 20px 0;
  align-items: flex-start;
`;
const CustomGrowPlain = styled(FlexGrow)`
  min-width: 150px;
  flex-grow: 0;
`;
const Label = styled.h5`
  font-size: 16px;
  font-style: normal;
  font-weight: 700;
  line-height: 24px;
  letter-spacing: 0px;
  text-align: left;
`;
interface SkillwInputs {
  title: string;
  description: string;
}

const EditKnowledgeArea = ({
  isOpen,
  setOpen,
  header,
  mode,
  currentId,
  onSaveComplete,
  isSnackbarOpen,
  setIsSnackbarOpen,
  setIsErrorOpen,
  setMessage,
  role,
}: EditKnowledgeTypes): JSX.Element => {
  const [count, setCount] = useState({ name: 0, description: 0 });
  const [subdomainData, setAreaData] = useState({
    id: "",
    description: "",
    title: "",
  });
  const {
    register,
    handleSubmit,
    control,
    watch,
    reset,
    setValue,
    formState: { errors },
  } = useForm<SkillwInputs>({
    mode: "onBlur",
    defaultValues: {
      title: subdomainData ? subdomainData.title : "",
      description: subdomainData ? subdomainData.description : "",
    },
  });

  useEffect(() => {
    getArea();
  }, [currentId.area_id]);

  const mapData = (data: any) => {
    setValue("title", data?.title || "");
    setValue("description", data?.description || "");
    setCount({
      ...count,
      description: data?.description?.length,
    });
  };

  const EditArea = (data: any) => {
    axios
      .put("/knowledgearea/update", { ...data, id: currentId.area_id })
      .then((res: any) => {
        setIsSnackbarOpen(true);
        setMessage("Updated Knowledge Area Successfully!");
        onSaveComplete();
      })
      .catch((error: any) => {
        setIsErrorOpen(true);
        setMessage(
          error?.response?.data?.error || "Failed to update knowledge area!"
        );
      });
  };

  const getArea = () => {
    axios
      .get(
        `knowledgearea?subdomain_id=${currentId.subdomain_id}&area_id=${currentId.area_id}`
      )
      .then((res: any) => {
        setAreaData(res.data.knowledgeareas[0]);
        mapData(res.data.knowledgeareas[0]);
      })
      .catch((error: any) => {
        setIsErrorOpen(true);
        setMessage(
          error?.response?.data?.error || "Failed to get knowledge area!"
        );
      });
  };
  return (
    <>
      <form onSubmit={handleSubmit(EditArea)}>
        {/* <CustomFlex>
          <FlexGrow>
            <Header>{header}</Header>
          </FlexGrow>
          <ClickableIcon
            size={3.125}
            fixedWidth={false}
            color="black"
            name="close"
            onClick={() => setOpen(false)}
          />
        </CustomFlex> */}
        {/* <CustomFlex
          style={{
            borderBottom: "none",
            alignItems: "flex-start",
            // overflowY: "scroll",
            padding:15
          }}
        > */}
        <FlexGrow
          style={{
            borderBottom: "none",
            alignItems: "flex-start",
            // overflowY: "scroll",
            padding: 15,
          }}
        >
          <CustomFlexPlain>
            <CustomGrowPlain>
              <Label>Title</Label>
            </CustomGrowPlain>
            <FlexGrow>
              <Input
                maxLength={64}
                style={{ width: "100%" }}
                isFullWidth
                {...register("title", { required: true })}
              />
              {errors.title && (
                <p
                  style={{
                    marginTop: 0,
                    color: theme.color.red800,
                  }}
                >
                  This field is required
                </p>
              )}
            </FlexGrow>
          </CustomFlexPlain>
          <CustomFlexPlain>
            <CustomGrowPlain>
              <Label>Description</Label>
            </CustomGrowPlain>
            <FlexGrow>
              <FlexBox
                space={0}
                alignItems="start"
                style={{ width: "100%" }}
                direction="column"
              >
                <FlexGrow style={{ width: "100%" }}>
                  <Controller
                    name="description"
                    control={control}
                    render={({ field }) => (
                      <InputTextArea
                        isFullWidth
                        style={{ minHeight: "100px", width: "100%" }}
                        value={field.value}
                        maxLength={2048}
                        onChange={(e: any) => {
                          field.onChange(e);
                          setCount({
                            ...count,
                            description: e.target.value.length,
                          });
                        }}
                      />
                    )}
                  />
                </FlexGrow>
                <FlexGrow style={{ textAlign: "end" }}>
                  <StyledText
                    style={{ fontSize: "14px" }}
                    color={theme.color.lightBlueGray500}
                  >
                    {count.description}/2048
                  </StyledText>
                </FlexGrow>
              </FlexBox>
            </FlexGrow>
          </CustomFlexPlain>
          <FlexBox>
            <FlexGrow></FlexGrow>
            <SaveButton
              disabled={role === "instructor"}
              className="reduce_opct_onhover"
              style={{
                padding: "8px 60px",
                color: "white",
              }}
            >
              <Icon style={{ paddingRight: "8px" }} name={"save"} /> Save
            </SaveButton>
          </FlexBox>
        </FlexGrow>
        {/* </CustomFlex> */}
      </form>
    </>
  );
};
export default EditKnowledgeArea;
